import InitialsLogo from "src/components/InitialsLogo";
import Table from "src/components/Tables/Table";
import InterviewStatusTag from "src/pages/job/components/InterviewStatusTag";
import { JobInterview } from "src/types";
import { dateFormat1 } from "src/utils/dates/formats";
import { InterviewTable } from "./type";
import OperationToggle from "./OperationToggle";
import { useState } from "react";
import LinkButton from "src/components/LinkButton";

const InterviewedTable = ({ data, reset }: InterviewTable) => {
  const [toggle, setToggle] = useState<number>();
  return (
    <Table
      data={data}
      heads={[
        "Rank",
        "Name | Email Address",
        "Recruiter",
        "Score",
        "Status",
        "Date Taken",
        "Action"
      ]}
      row={(i: JobInterview, index) => {
        const { id, email, first_name, last_name, Interview, slug, Inviter } = i;
        const { ai_score, date_completed } = Interview;
        return [
          <p className="max-w-[18px] mx-auto">#{index + 1}</p>,
          <div>
            <p>{`${first_name} ${last_name}`}</p>
            <p className="max-w-[207px] overflow-hidden text-ellipsis mt-2">{email}</p>
          </div>,
          Inviter ? <InitialsLogo user={Inviter.User} /> : "N/A",
          <p className="max-w-[30px] overflow-hidden text-ellipsis">
            {ai_score ? ai_score + "%" : "-"}
          </p>,
          <InterviewStatusTag i={Interview} />,
          <p>{date_completed ? dateFormat1(date_completed) : "-"}</p>,
          <div className="flex gap-4 ">
            <LinkButton
              href={date_completed ? "/job/interview/" + slug : undefined}
              target="_blank"
              buttonProps={{
                disabled: !date_completed,
                className: "!text-sm !rounded-3xl !w-fit !px-4 mr-4"
              }}
            >
              View Insights
            </LinkButton>
            <OperationToggle
              value={toggle === id}
              onChange={setToggle}
              interview={i}
              onRefresh={reset}
            />
          </div>
        ];
      }}
    />
  );
};

export default InterviewedTable;
